import { render, staticRenderFns } from "./AddDreamLog.vue?vue&type=template&id=825b62b0"
import script from "./AddDreamLog.vue?vue&type=script&lang=js"
export * from "./AddDreamLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports